import "./Coupon.css";
import React, {useEffect, useRef, useState} from "react";
import {
  formatTime,
  formatNumber,
  createSafeHtml,
  FaqMock, sendVerificationCode, verifyCode, resendCode,
} from "../../utils/UtilsFunc";
import { useForm } from "react-hook-form";
import { useMembership } from "../../hooks/MembershipProvider/MembershipProvider";
import { useApi } from "../../hooks/ApiProvider/ApiProvider";
import {useLocation, useNavigate, useSearchParams} from "react-router-dom";
import { Collapse } from "react-bootstrap";
import useAndroidBridge from "../../hooks/useAndroidBridge";
import YesNoPopup from "../YesNoPopup";
import Confirm from "../Modals/Confirm";
import Modals from "../Modals/Modals";

const Coupon = () => {
  const { user, isAuthenticated, logout, refreshUser } = useMembership();
  const { activateMembershipByCoupon } = useApi();
  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
  } = useForm({ mode: "onChange" });
  const [error, setError] = useState(``);
  const [userAct, setUserAct] = useState(`ready`);
  const [faqList, setFaqList] = useState<any | null>([]);
  const [planShow, setPlanShow] = useState(false);
  const [activatedResult, setActivatedResult] = useState<any | null>(null);
  const loaction = useLocation();
  const navigate = useNavigate();
  const chk = localStorage.getItem("membership_access_token");
  const { isEmbed } = useMembership();
  const { sendToAndroid } = useAndroidBridge();
  const [memberShipChk, setMemberShipchk] = useState(false);
  const [searchParams] = useSearchParams();
  const [sendCodeState, setSendCodeState] = useState<any>(false);
  const [timer, setTimer] = useState(300);
  const [sessionId,setSessionId] = useState<any>(``);
  const couponPhoneRef = useRef<any>(false);
  const coupon_code = watch(`coupon_code`);
  const startTimer = useRef<any>(null)

  // 쿠폰번호 제출
  const onSubmit = async () => {
    
    if(!user?.phone_number_verified) {
      if(!couponPhoneRef.current) {
        alert(`전화번호 인증을 완료해주세요`);
        return
      }
    }
    await activateMembershipByCoupon(coupon_code)
      .then((res: any) => {
        console.log(res);
        if (res.success === true) {
          setActivatedResult(res?.plan);
          setUserAct("done");
        } else {
          setError(`사용이 가능한 쿠폰이 아닙니다.`);
        }
      })
      .catch((err: any) => {
        console.log(err);
      });
  };

  const getReady = async () => {
    let homeInfo:any = await refreshUser();
    if(homeInfo?.membership?.subscription?.enabled) {
      alert(`멤버십이 존재 합니다.`);
      navigate("/");
      return
    }
    if (!chk) {
      alert(`로그인 후 이용 가능합니다.`);
      navigate("/login", { state: "coupon_link" });
      return;
    }
    
  };
  
  const embedReady = async () => {
    console.log(`--------------------->routing app-------------------------`);
    let homeInfo:any = await refreshUser();
    if(homeInfo?.membership?.subscription?.enabled) {
      setMemberShipchk(true);
    }
    console.log(homeInfo);
  }
  
  
  const onHandleCollapse = (id: number) => {
    let temp = faqList?.map((val: any, idx: number) => {
      if (idx === id) {
        return {
          ...val,
          open: !val?.open,
        };
      }
      return { ...val };
    });
    console.log(temp);
    setFaqList(temp);
  };
  
  const onHandleCode = async () => {
    let {success,sessionId} = await sendVerificationCode(watch(`phoneNumChk`),user?.id);
    if(success) {
      setSessionId(sessionId);          // 세션 id 추가
      setSendCodeState(true);     // 인증번호 입력창 노출
      // 정상적으로 전송되면 타이머 시작
      startTimer.current =  setInterval(()=>{
        setTimer((prev)=>prev - 1);
      },1000);
    }
  }
  
  const codeChk = async () => {
    // 정상적 승인처리 될경우 다음페이지 넘어가기
    let res = await verifyCode(watch(`phoneNumChk`),watch('phoneCode'),sessionId);
    if(res === 'ok') {
      alert(`인증번호 확인되었습니다.`);
      clearInterval(startTimer.current);
      setTimer(300);
      couponPhoneRef.current = true;
      return;
    }
    // 실패시 인증번호 재전송 알림 노출
    if(res === 'ng') {
      alert(`인증번호가 맞지 않습니다 다시 확인해주세요.`);
      return;
    }
  }
  
  const onRecode = async () => {
    let res = await resendCode(watch(`phoneNumChk`),user?.id);
    if(res?.success) {
      setTimer(300);
      // console.log(res?.sessionId,'/[sessionId]');
      setSessionId(res?.sessionId);
      alert(`인증번호가 재전송 되었습니다.`);
      return
    } else {
      alert(`error`);
      return
    }
  }
  
  
  useEffect(() => {
    console.log(coupon_code,'/[coupon_code]');
    if(user?.phone_number_verified) {
      couponPhoneRef.current = coupon_code?.length >= 9;
    }
  }, [coupon_code]);
  
  useEffect(() => {
    let temp: any = FaqMock?.map((obj) => {
      return {
        ...obj,
        open: false,
      };
    });
    setFaqList(temp);
    
    return ()=> {
      clearInterval(startTimer.current) // 타이머 초기화
    }
  }, []);
  
  useEffect(() => {
    if(0 >= timer) {  // 제한시간 초과 될경우
      alert(`제한시간이 초과 되었습니다.`);
      clearInterval(startTimer.current);
    }
  }, [timer]);

  useEffect(() => {
    if(!searchParams?.get('token')) {    // 웹에서 접근할 경우
      console.log(`isEmbed`)
      getReady();
    } else {
      embedReady();
    }
  }, [isAuthenticated, isEmbed()]);

  console.log(isAuthenticated, "/[test]");
  console.log(couponPhoneRef.current, "couponPhoneRef");
  console.log(searchParams?.get('token'), "searchParams");
  
  return (
    <>
      {/* 앱 전용 버튼 */}
      {isEmbed() && (
        <div className={`mobile_app_header`} style={{ background: "#fff" }}>
          <button
            onClick={() => sendToAndroid("go-to-page", "")}
            className={`btn btn_back`}
          ></button>
          <p className={`mobile_app_header_text`}>선물 쿠폰 코드 등록</p>
        </div>
      )}
      <div className={`content_wrap coupon`}>
        {isAuthenticated && userAct === `ready` && (
          <>
            <div className={`section_wrap`}>
              <div className={`sec sec_1`}>
                <div className={`form_box`}>
                  <h3 className={`h2`}>
                    쿠폰 번호
                  </h3>
                  <div className={`form_group`}>
                    <input
                      {...register("coupon_code")}
                      maxLength={10}
                      onKeyDown={(e) => {
                        if (e.key === "Enter") {
                          onSubmit();
                        }
                      }}
                      placeholder={`쿠폰 번호 입력`}
                      className={`form_control code max-md:w-[100%]`}
                      type={`text`}
                    />
                  
                  </div>
                </div>
              </div>
              {(!user?.phone_number_verified) && (
                <div className={`sec sec_2`}>
                  <div className={`form_box`}>
                    <h3 className={`h2`}>
                      회원 연락처
                    </h3>
                    <p className={`caption`}>
                      결제, 전자책 및 실물책 진행 관련 안내를 위해 휴대폰 번호 인증이 필요해요.
                      광고/마케팅에는 사용하지 않아요.
                    </p>
                    <div className={`form_group flex`}>
                      <input
                        {...register("phoneNumChk", {
                          pattern: {
                            value: /^\d+$/, // ^ $로 전체 매칭
                            message: "전화번호 형식이 아닙니다.",
                          },
                        })}
                        disabled={couponPhoneRef.current}
                        inputMode="numeric"
                        onKeyDown={(e) => {
                          if (!/[0-9]/.test(e.key) && e.key !== "Backspace") {
                            e.preventDefault();
                          }
                        }}
                        // disabled={sendCodeState}
                        maxLength={11}
                        placeholder={`휴대폰 번호 (번호만 입력)`}
                        className={`form_control`}
                        type={`text`}
                      />
                      {sendCodeState ? (
                        <button
                          disabled={couponPhoneRef.current}
                          onClick={onRecode}
                          className={`btn ${watch(`phoneNumChk`)?.length >= 11 ? "" : "dis"} btn-primary ms-[12px] md:!px-[32px]`}
                        >
                          재전송
                        </button>
                      ) : (
                        <button
                          disabled={couponPhoneRef.current}
                          onClick={onHandleCode}
                          className={`btn ${watch(`phoneNumChk`)?.length >= 11 ? "" : "dis"} btn-primary ms-[12px] md:!px-[32px]`}>
                          인증 번호 전송
                        </button>
                      )}
                    
                    </div>
                    {sendCodeState && (
                      <>
                        <div className={`form_group flex mt-5`}>
                          <input
                            {...register("phoneCode", {
                              pattern: {
                                value: /^\d+$/, // ^ $로 전체 매칭
                                message: "인증번호 입력형식이 아닙니다.",
                              },
                            })}
                            disabled={couponPhoneRef.current}
                            inputMode="numeric"
                            onKeyDown={(e) => {
                              if (!/[0-9]/.test(e.key) && e.key !== "Backspace") {
                                e.preventDefault();
                              }
                            }}
                            maxLength={6}
                            placeholder={`인증번호 입력`}
                            className={`form_control`}
                            type={`text`}
                          />
                          <button
                            onClick={codeChk}
                            disabled={couponPhoneRef.current}
                            className={`btn ${watch(`phoneCode`)?.length >= 6 ? "" : "dis"} btn-primary ms-[12px] md:!px-[32px]`}>
                            확인
                          </button>
                        </div>
                        <div className={`timer`}>{formatTime(timer)}</div>
                      </>
                    )}
                  </div>
                </div>
              )}
              
              
              {/*<div className={`sec sec_1`}>*/}
              {/*  <div className={`small_wrap`}>*/}
              {/*    <div className={`tit`}>*/}
              {/*      <img src={"/contents/icons_gift.png"} alt={`쿠폰 아이콘`} className={`mx-auto md:mb-[20px]`}/>*/}
              {/*      <h2 className={`h2 text-center`}>*/}
              {/*        쿠폰 번호를 입력해 주세요.*/}
              {/*      </h2>*/}
              {/*    </div>*/}
              {/*    <div className={`form_group`}>*/}
              {/*      <div className={`flex max-md:block relative form_control_input_box`}>*/}
              {/*        <input*/}
              {/*          {...register("coupon_code")}*/}
              {/*          maxLength={10}*/}
              {/*          onKeyDown={(e) => {*/}
              {/*            if (e.key === "Enter") {*/}
              {/*              onSubmit();*/}
              {/*            }*/}
              {/*          }}*/}
              {/*          placeholder={`쿠폰 번호 입력`}*/}
              {/*          className={`form_control w-[100%] code`}*/}
              {/*          type={`text`}*/}
              {/*        />*/}
              {/*        /!*모바일용 텍스트*!/*/}
              {/*        <div className={`alert_txt max-md:block hidden mb-[20px]`}>*/}
              {/*          <p className={`txt body2`}>{error}</p>*/}
              {/*        </div>*/}
              {/*        /!*모바일용 텍스트*!/*/}
              {/*        <button type="submit" className={`btn btn-primary ${coupon_code?.length >= 9 ? `` : `dis`}`} onClick={onSubmit}>*/}
              {/*          입력 완료*/}
              {/*        </button>*/}
              {/*      </div>*/}
              {/*      /!*pc용 텍스트*!/*/}
              {/*      <div className={`alert_txt md:block hidden`}>*/}
              {/*        <p className={`txt body2`}>{error}</p>*/}
              {/*      </div>*/}
              {/*      /!*모바일용 텍스트*!/*/}
              {/*    </div>*/}
              {/*    <div className={`coupon_info`}>*/}
              {/*      <p className={`tit`}>쿠폰 사용 안내</p>*/}
              {/*      <p className={`txt`}>*/}
              {/*        선물받으신 쿠폰은 1회에 한해 사용 가능하며, 등록 후 취소가*/}
              {/*        불가능합니다. 유효기간이 지난 쿠폰은 사용할 수 없으니 기한*/}
              {/*        내 등록해 주세요.*/}
              {/*      </p>*/}
              {/*    </div>*/}
              {/*  </div>*/}
              {/*</div>*/}
              <div className={`sec sec_3 ${isEmbed() ? 'mobile' : 'pc'}`}>
                <div className={`small_wrap`}>
                  <p className={`h2 tit`}>자주 묻는 질문</p>
                  <div className={`faq_ul`}>
                    {faqList?.map((obj: any, idx: number) => {
                      let act = obj?.open ? "on" : "";
                      return (
                        <div key={idx} className={`faq_li`}>
                          <button
                            onClick={() => onHandleCollapse(idx)}
                            className={`tab ${act}`}
                          >
                            {obj?.title}
                          </button>
                          <Collapse in={obj?.open}>
                            <div className={`txt`}>{obj?.txt}</div>
                          </Collapse>
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>
              <div className={`footer_btn`}>
                <div className={`btn_group`}>
                  <button onClick={onSubmit}
                          className={`btn ${couponPhoneRef?.current ? `` : `dis`} btn-primary block w-[100%]`}>
                    확인
                  </button>
                </div>
              </div>
            </div>
          </>
        )}
        
        {isAuthenticated && userAct === `done` && (
          <>
            <div className={`content_wrap coupon`}>
              <div className={`section_wrap`}>
                <div className={`sec sec_1`}>
                  <div className={`result_message`}>
                  <img
                      src={`../contents/join_end.png`}
                      alt={``}
                      className={`m-auto`}
                    />
                    <h3 className={`h3`}>쿠폰 등록이 완료 되었어요.</h3>
                  </div>
                </div>
                <div className={`sec sec_2`}>
                  <div className={`order_done_result`}>
                    {/**------------------------pc------------------------**/}
                    <div className={`proc_info max-md:hidden`}>
                      <h3 className={`text-center body1_sb`}>
                        {activatedResult?.fullName} 플랜
                      </h3>
                      <ul>
                        {activatedResult?.features.map(
                          (item: any, index: number) => (
                            <li className={`body2`} key={index}>
                              <p
                                dangerouslySetInnerHTML={createSafeHtml(item)}
                              ></p>
                            </li>
                          )
                        )}
                        {/*<li>AI 인터뷰(10분) 15회</li>*/}
                        {/*<li>*/}
                        {/*  이용 기간 30일<br/>(기간 내 전자책 신청까지 완료해요)*/}
                        {/*</li>*/}
                        {/*<li>기본 표지 디자인 제공</li>*/}
                        {/*<li>전자책 (PDF) 제공</li>*/}
                      </ul>
                    </div>
                    {/**--------------------mobile------------------------**/}
                    <div className={`proc_info_mo md:hidden`}>
                      <button
                        className={`tab ${planShow ? "on" : ""}`}
                        onClick={() => setPlanShow(!planShow)}
                      >
                        {activatedResult?.fullName} 플랜
                      </button>
                      <Collapse in={planShow}>
                        <ul>
                          {activatedResult?.features.map(
                            (item: any, index: number) => (
                              <li className={`body2`} key={index}>
                                <p
                                  dangerouslySetInnerHTML={createSafeHtml(item)}
                                ></p>
                              </li>
                            )
                          )}
                        </ul>
                      </Collapse>
                    </div>
                  </div>
                </div>
                <div className={`sec sec_3 text-center`}>
                  {/*일반 결제시 노출*/}
                  <h3 className={`h3 pb-[40px]`}>
                    기억의 서랍 앱 설치 후<br/>
                    인터뷰를 시작해 보세요
                  </h3>
                  <div className={`qr_code pb-[40px]`}>
                    <button
                      onClick={() =>
                        window.open(
                          `https://play.google.com/store/apps/details?id=kr.co.utopsoft.vcall&pcampaignid=web_share`,
                          `_blank`
                        )
                      }
                      className={`play_store mb-[16px]`}
                    >
                      <img src={`/contents/play_store_btn.png`} alt={``}/>
                    </button>
                    <img
                      src={`/contents/play_store_qr.png`}
                      alt={``}
                      className={`max-w-[94px] mx-auto`}
                    />
                    <p>휴대폰 카메라로 스캔</p>
                  </div>
                  <button
                    onClick={() => navigate(`/guide`)}
                    className={`get_guide`}
                  >
                    자서전 제작과정 자세히 보기
                  </button>
                  {/*쿠폰 결제시 노출*/}
                  {/*<h3 className={`h3`}>스토리북 선물, 이런 과정을 거쳐 완성돼요</h3>*/}
                </div>
              </div>
            </div>
          </>
        )}
      </div>
      <Modals
        // message={`이미 사용중인 상품이 있어서 새로운 쿠폰을 등록할 수 없어요`}
        show={memberShipChk}
        alertType={`default`}
        onClose={(res: any) => {
          setMemberShipchk(res)
          sendToAndroid("go-to-page", "")
        }}
      >
        이미 사용중인 상품이 있어서<br/>새로운 쿠폰을 등록할 수 없어요
      </Modals>
    </>
  );
};
export default Coupon;
